import { LightPalette, MediumPalette, DarkPalette } from '../../ui/colors';

const palette = [...MediumPalette, ...LightPalette, ...DarkPalette];

export default palette;
